module.exports = __webpack_public_path__ + "static/media/eye-close.08dcc8df.svg";